import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import type { CheckoutFormValues } from "@/domain/checkout";

type TreatmentSelectionState = {
  selectedBodyPart: string | null;
  selectedTemplateKey: string | null;
  selectedTreatmentName: string | null;
  customDescription: string;
  personalDetails: CheckoutFormValues | null;
  actions: {
    setBodyPart: (bodyPart: string) => void;
    selectTreatment: (key: string, name: string) => void;
    setTreatmentWithBodyPart: (bodyPart: string, key: string, name: string) => void;
    setCustomDescription: (description: string) => void;
    setPersonalDetails: (details: CheckoutFormValues) => void;
    reset: () => void;
  };
};

export const useTreatmentSelectionStore = create<TreatmentSelectionState>()(
  persist(
    set => ({
      selectedBodyPart: null,
      selectedTemplateKey: null,
      selectedTreatmentName: null,
      customDescription: "",
      personalDetails: null,
      actions: {
        setBodyPart: (bodyPart: string) =>
          set({ selectedBodyPart: bodyPart, selectedTemplateKey: null, selectedTreatmentName: null }),
        selectTreatment: (key: string, name: string) =>
          set({ selectedTemplateKey: key, selectedTreatmentName: name }),
        setTreatmentWithBodyPart: (bodyPart: string, key: string, name: string) =>
          set({ selectedBodyPart: bodyPart, selectedTemplateKey: key, selectedTreatmentName: name }),
        setCustomDescription: (description: string) => set({ customDescription: description }),
        setPersonalDetails: (details: CheckoutFormValues) => set({ personalDetails: details }),
        reset: () =>
          set({ selectedBodyPart: null, selectedTemplateKey: null, selectedTreatmentName: null, customDescription: "", personalDetails: null }),
      },
    }),
    {
      name: "treatment-selection",
      storage: createJSONStorage(() => localStorage),
      partialize: ({ selectedBodyPart, selectedTemplateKey, selectedTreatmentName, customDescription, personalDetails }) => ({
        selectedBodyPart,
        selectedTemplateKey,
        selectedTreatmentName,
        customDescription,
        personalDetails,
      }),
    },
  ),
);
